/**
 * Fingerprint BotD v1.1.0 - Copyright (c) FingerprintJS, Inc, 2022 (https://fingerprint.com)
 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
 */
var e = function (n, t) {
  return (
    (e =
      Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array &&
        function (e, n) {
          e.__proto__ = n;
        }) ||
      function (e, n) {
        for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
      }),
    e(n, t)
  );
};
function n(e, n, t, r) {
  return new (t || (t = Promise))(function (o, i) {
    function a(e) {
      try {
        c(r.next(e));
      } catch (n) {
        i(n);
      }
    }
    function u(e) {
      try {
        c(r.throw(e));
      } catch (n) {
        i(n);
      }
    }
    function c(e) {
      var n;
      e.done
        ? o(e.value)
        : ((n = e.value),
          n instanceof t
            ? n
            : new t(function (e) {
                e(n);
              })).then(a, u);
    }
    c((r = r.apply(e, n || [])).next());
  });
}
function t(e, n) {
  var t,
    r,
    o,
    i,
    a = {
      label: 0,
      sent: function () {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: [],
    };
  return (
    (i = { next: u(0), throw: u(1), return: u(2) }),
    'function' == typeof Symbol &&
      (i[Symbol.iterator] = function () {
        return this;
      }),
    i
  );
  function u(i) {
    return function (u) {
      return (function (i) {
        if (t) throw new TypeError('Generator is already executing.');
        for (; a; )
          try {
            if (
              ((t = 1),
              r &&
                (o =
                  2 & i[0]
                    ? r.return
                    : i[0]
                    ? r.throw || ((o = r.return) && o.call(r), 0)
                    : r.next) &&
                !(o = o.call(r, i[1])).done)
            )
              return o;
            switch (((r = 0), o && (i = [2 & i[0], o.value]), i[0])) {
              case 0:
              case 1:
                o = i;
                break;
              case 4:
                return a.label++, { value: i[1], done: !1 };
              case 5:
                a.label++, (r = i[1]), (i = [0]);
                continue;
              case 7:
                (i = a.ops.pop()), a.trys.pop();
                continue;
              default:
                if (
                  !((o = a.trys),
                  (o = o.length > 0 && o[o.length - 1]) || (6 !== i[0] && 2 !== i[0]))
                ) {
                  a = 0;
                  continue;
                }
                if (3 === i[0] && (!o || (i[1] > o[0] && i[1] < o[3]))) {
                  a.label = i[1];
                  break;
                }
                if (6 === i[0] && a.label < o[1]) {
                  (a.label = o[1]), (o = i);
                  break;
                }
                if (o && a.label < o[2]) {
                  (a.label = o[2]), a.ops.push(i);
                  break;
                }
                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }
            i = n.call(e, a);
          } catch (u) {
            (i = [6, u]), (r = 0);
          } finally {
            t = o = 0;
          }
        if (5 & i[0]) throw i[1];
        return { value: i[0] ? i[1] : void 0, done: !0 };
      })([i, u]);
    };
  }
}
function r(e, n) {
  return -1 !== e.indexOf(n);
}
function o(e, n) {
  return -1 !== e.indexOf(n);
}
function i(e, n) {
  if ('find' in e) return e.find(n);
  for (var t = 0; t < e.length; t++) if (n(e[t], t, e)) return e[t];
}
function a(e) {
  return Object.getOwnPropertyNames(e);
}
function u(e) {
  for (var n = [], t = 1; t < arguments.length; t++) n[t - 1] = arguments[t];
  for (
    var o = function (n) {
        if ('string' == typeof n) {
          if (r(e, n)) return { value: !0 };
        } else if (
          null !=
          i(e, function (e) {
            return n.test(e);
          })
        )
          return { value: !0 };
      },
      a = 0,
      u = n;
    a < u.length;
    a++
  ) {
    var c = u[a],
      s = o(c);
    if ('object' == typeof s) return s.value;
  }
  return !1;
}
function c(e) {
  return e.reduce(function (e, n) {
    return e + (n ? 1 : 0);
  }, 0);
}
var s = (function (n) {
  function t(e, r) {
    var o = n.call(this, r) || this;
    return (o.state = e), (o.name = 'BotdError'), Object.setPrototypeOf(o, t.prototype), o;
  }
  return (
    (function (n, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Class extends value ' + String(t) + ' is not a constructor or null');
      function r() {
        this.constructor = n;
      }
      e(n, t),
        (n.prototype = null === t ? Object.create(t) : ((r.prototype = t.prototype), new r()));
    })(t, n),
    t
  );
})(Error);
function d() {
  var e,
    n,
    t = window,
    r = navigator;
  return c([
    'webkitPersistentStorage' in r,
    'webkitTemporaryStorage' in r,
    0 === r.vendor.indexOf('Google'),
    'webkitResolveLocalFileSystemURL' in t,
    'BatteryManager' in t,
    'webkitMediaStream' in t,
    'webkitSpeechGrammar' in t,
  ]) >= 5
    ? 'chromium'
    : c([
        'ApplePayError' in t,
        'CSSPrimitiveValue' in t,
        'Counter' in t,
        0 === r.vendor.indexOf('Apple'),
        'getStorageUpdates' in r,
        'WebKitMediaKeys' in t,
      ]) >= 4
    ? 'webkit'
    : c([
        'buildID' in navigator,
        'MozAppearance' in
          (null !==
            (n = null === (e = document.documentElement) || void 0 === e ? void 0 : e.style) &&
          void 0 !== n
            ? n
            : {}),
        'onmozfullscreenchange' in t,
        'mozInnerScreenX' in t,
        'CSSMozDocumentRule' in t,
        'CanvasCaptureMediaStream' in t,
      ]) >= 4
    ? 'gecko'
    : 'unknown';
}
function f() {
  var e,
    n = null === (e = navigator.userAgent) || void 0 === e ? void 0 : e.toLowerCase();
  return o(n, 'wechat')
    ? 'wechat'
    : o(n, 'firefox')
    ? 'firefox'
    : o(n, 'opera') || o(n, 'opr')
    ? 'opera'
    : o(n, 'chrome')
    ? 'chrome'
    : o(n, 'safari')
    ? 'safari'
    : o(n, 'trident') || o(n, 'msie')
    ? 'internet_explorer'
    : 'unknown';
}
function l() {
  if ('webkit' !== d()) return !1;
  var e = window;
  return (
    c([
      'safari' in e,
      !('DeviceMotionEvent' in e),
      !('ongestureend' in e),
      !('standalone' in navigator),
    ]) >= 3
  );
}
var v = {
  detectAppVersion: function (e) {
    var n = e.appVersion;
    return (
      0 === n.state &&
      (/headless/i.test(n.value)
        ? 'headless_chrome'
        : /electron/i.test(n.value)
        ? 'electron'
        : /slimerjs/i.test(n.value)
        ? 'slimerjs'
        : void 0)
    );
  },
  detectDocumentAttributes: function (e) {
    var n = e.documentAttributes;
    return 0 === n.state && (u(n.value, 'selenium', 'webdriver', 'driver') ? 'selenium' : void 0);
  },
  detectDocumentProperties: function (e) {
    var n = e.documentProps;
    return (
      0 === n.state &&
      (u(
        n.value,
        'selenium',
        '__fxdriver_unwrapped',
        '__selenium_unwrapped',
        '__webdriver_evaluate',
        '__driver_evaluate',
        '__webdriver_unwrapped',
        '__driver_unwrapped',
        '__selenium_evaluate',
        '__webdriver_script_function',
        '__webdriver_script_func',
        '__webdriver_script_fn',
        '__fxdriver_evaluate',
        '__webdriverFunc',
        '$chrome_asyncScriptInfo',
        '__$webdriverAsyncExecutor',
        '__lastWatirAlert',
        '__lastWatirConfirm',
        '__lastWatirPrompt',
        '_WEBDRIVER_ELEM_CACHE',
        'ChromeDriverw',
        'selenium-evaluate',
        '_Selenium_IDE_Recorder',
        /^([a-z]){3}_.*_(Array|Promise|Symbol)$/
      )
        ? 'selenium'
        : void 0)
    );
  },
  detectErrorTrace: function (e) {
    var n = e.errorTrace;
    return 0 === n.state && (/PhantomJS/i.test(n.value) ? 'phantomjs' : void 0);
  },
  detectEvalLengthInconsistency: function (e) {
    var n = e.evalLength;
    if (0 === n.state) {
      var t = n.value,
        o = f();
      return (
        (37 === t && !r(['firefox', 'safari'], o)) ||
        (39 === t && !r(['internet_explorer'], o)) ||
        (33 === t && !r(['chrome', 'opera', 'wechat'], o))
      );
    }
  },
  detectFunctionBind: function (e) {
    if (-2 === e.functionBind.state) return 'phantomjs';
  },
  detectLanguagesLengthInconsistency: function (e) {
    var n = e.languages;
    if (0 === n.state && 0 === n.value.length) return 'headless_chrome';
  },
  detectNotificationPermissions: function (e) {
    var n = e.notificationPermissions;
    return 'chrome' === f() && (0 === n.state && n.value ? 'headless_chrome' : void 0);
  },
  detectPluginsArray: function (e) {
    var n = e.pluginsArray;
    if (0 === n.state && !n.value) return 'headless_chrome';
  },
  detectPluginsLengthInconsistency: function (e) {
    var n = e.pluginsLength;
    if (0 === n.state) {
      var t = f();
      if (
        !(
          ('chromium' === d() &&
            (function () {
              var e = d(),
                n = 'chromium' === e,
                t = 'gecko' === e;
              if (!n && !t) return !1;
              var r = window;
              return (
                c([
                  'onorientationchange' in r,
                  'orientation' in r,
                  n && !('SharedWorker' in r),
                  t && /android/i.test(navigator.appVersion),
                ]) >= 2
              );
            })()) ||
          ('safari' === t && !l())
        )
      )
        return 0 === n.value ? 'headless_chrome' : void 0;
    }
  },
  detectProcess: function (e) {
    var n,
      t = e.process;
    return (
      0 === t.state &&
      ('renderer' === t.value.type ||
      null != (null === (n = t.value.versions) || void 0 === n ? void 0 : n.electron)
        ? 'electron'
        : void 0)
    );
  },
  detectUserAgent: function (e) {
    var n = e.userAgent;
    return (
      0 === n.state &&
      (/PhantomJS/i.test(n.value)
        ? 'phantomjs'
        : /Headless/i.test(n.value)
        ? 'headless_chrome'
        : /Electron/i.test(n.value)
        ? 'electron'
        : /slimerjs/i.test(n.value)
        ? 'slimerjs'
        : void 0)
    );
  },
  detectWebDriver: function (e) {
    var n = e.webDriver;
    if (0 === n.state && n.value) return 'headless_chrome';
  },
  detectWebGL: function (e) {
    var n = e.webGL;
    if (0 === n.state) {
      var t = n.value,
        r = t.vendor,
        o = t.renderer;
      if ('Brian Paul' == r && 'Mesa OffScreen' == o) return 'headless_chrome';
    }
  },
  detectWindowExternal: function (e) {
    var n = e.windowExternal;
    return 0 === n.state && (/Sequentum/i.test(n.value) ? 'sequentum' : void 0);
  },
  detectWindowProperties: function (e) {
    var n = e.windowProps;
    return (
      0 === n.state &&
      (u(n.value, 'webdriver', 'domAutomation', 'domAutomationController')
        ? 'headless_chrome'
        : u(n.value, '_selenium', '_Selenium_IDE_Recorder', 'callSelenium')
        ? 'selenium'
        : u(n.value, 'callPhantom', '_phantom')
        ? 'phantomjs'
        : u(n.value, '__nightmare')
        ? 'nightmare'
        : u(n.value, 'emit')
        ? 'couchjs'
        : u(n.value, 'spawn')
        ? 'rhino'
        : u(n.value, 'CefSharp')
        ? 'cefsharp'
        : void 0)
    );
  },
  detectWindowSize: function (e) {
    var n = e.windowSize;
    if (0 !== n.state) return !1;
    var t = n.value,
      r = t.outerWidth,
      o = t.outerHeight;
    return void 0 !== document.hasFocus && document.hasFocus() && 0 === r && 0 === o
      ? 'headless_chrome'
      : void 0;
  },
  detectMimeTypesConsistent: function (e) {
    var n = e.mimeTypesConsistent;
    if (0 === n.state && !n.value) return 'unknown';
  },
  detectProductSub: function (e) {
    var n = e.productSub;
    if (0 !== n.state) return !1;
    var t = f();
    return ('chrome' !== t && 'safari' !== t && 'opera' !== t && 'wechat' !== t) ||
      '20030107' === n.value
      ? void 0
      : 'unknown';
  },
};
function p(e, n) {
  return 'number' == typeof e && isNaN(e) ? n : e;
}
function w(e) {
  return parseInt(e);
}
var h = {
    userAgent: function () {
      return navigator.userAgent;
    },
    appVersion: function () {
      var e = navigator.appVersion;
      if (null == e) throw new s(-1, 'navigator.appVersion is undefined');
      return e;
    },
    rtt: function () {
      if (void 0 === navigator.connection) throw new s(-1, 'navigator.connection is undefined');
      if (void 0 === navigator.connection.rtt)
        throw new s(-1, 'navigator.connection.rtt is undefined');
      return navigator.connection.rtt;
    },
    windowSize: function () {
      return {
        outerWidth: window.outerWidth,
        outerHeight: window.outerHeight,
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      };
    },
    pluginsLength: function () {
      if (void 0 === navigator.plugins) throw new s(-1, 'navigator.plugins is undefined');
      return navigator.plugins.length;
    },
    pluginsArray: function () {
      if (void 0 === navigator.plugins) throw new s(-1, 'navigator.plugins is undefined');
      if (void 0 === window.PluginArray) throw new s(-1, 'window.PluginArray is undefined');
      return navigator.plugins instanceof PluginArray;
    },
    errorTrace: function () {
      try {
        null[0]();
      } catch (e) {
        if (e instanceof Error && null != e.stack) return e.stack.toString();
      }
      throw new s(-3, 'errorTrace signal unexpected behaviour');
    },
    productSub: function () {
      var e = navigator.productSub;
      if (void 0 === e) throw new s(-1, 'navigator.productSub is undefined');
      return e;
    },
    windowExternal: function () {
      if (void 0 === window.external) throw new s(-1, 'window.external is undefined');
      var e = window.external;
      if ('function' != typeof e.toString)
        throw new s(-2, 'window.external.toString is not a function');
      return e.toString();
    },
    mimeTypesConsistent: function () {
      if (void 0 === navigator.mimeTypes) throw new s(-1, 'navigator.mimeTypes is undefined');
      for (
        var e = navigator.mimeTypes,
          n = Object.getPrototypeOf(e) === MimeTypeArray.prototype,
          t = 0;
        t < e.length;
        t++
      )
        n && (n = Object.getPrototypeOf(e[t]) === MimeType.prototype);
      return n;
    },
    evalLength: function () {
      return eval.toString().length;
    },
    webGL: function () {
      var e = document.createElement('canvas');
      if ('function' != typeof e.getContext)
        throw new s(-2, 'HTMLCanvasElement.getContext is not a function');
      var n = e.getContext('webgl');
      if (null === n) throw new s(-4, 'WebGLRenderingContext is null');
      if ('function' != typeof n.getParameter)
        throw new s(-2, 'WebGLRenderingContext.getParameter is not a function');
      return { vendor: n.getParameter(n.VENDOR), renderer: n.getParameter(n.RENDERER) };
    },
    webDriver: function () {
      if (null == navigator.webdriver) throw new s(-1, 'navigator.webdriver is undefined');
      return navigator.webdriver;
    },
    languages: function () {
      var e,
        n = navigator,
        t = [],
        r = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
      if ((void 0 !== r && t.push([r]), Array.isArray(n.languages)))
        ('chromium' === d() &&
          c([
            !('MediaSettingsRange' in (e = window)),
            'RTCEncodedAudioFrame' in e,
            '' + e.Intl == '[object Intl]',
            '' + e.Reflect == '[object Reflect]',
          ]) >= 3) ||
          t.push(n.languages);
      else if ('string' == typeof n.languages) {
        var o = n.languages;
        o && t.push(o.split(','));
      }
      return t;
    },
    notificationPermissions: function () {
      return n(this, void 0, void 0, function () {
        var e, n;
        return t(this, function (t) {
          switch (t.label) {
            case 0:
              if (void 0 === window.Notification)
                throw new s(-1, 'window.Notification is undefined');
              if (void 0 === navigator.permissions)
                throw new s(-1, 'navigator.permissions is undefined');
              if ('function' != typeof (e = navigator.permissions).query)
                throw new s(-2, 'navigator.permissions.query is not a function');
              t.label = 1;
            case 1:
              return t.trys.push([1, 3, , 4]), [4, e.query({ name: 'notifications' })];
            case 2:
              return (
                (n = t.sent()),
                [2, 'denied' === window.Notification.permission && 'prompt' === n.state]
              );
            case 3:
              throw (t.sent(), new s(-3, 'notificationPermissions signal unexpected behaviour'));
            case 4:
              return [2];
          }
        });
      });
    },
    documentAttributes: function () {
      if (void 0 === document.documentElement)
        throw new s(-1, 'document.documentElement is undefined');
      return Array.from(document.documentElement.attributes).map(function (e) {
        return e.name;
      });
    },
    functionBind: function () {
      if (void 0 === Function.prototype.bind)
        throw new s(-2, 'Function.prototype.bind is undefined');
      return Function.prototype.bind.toString();
    },
    process: function () {
      if (void 0 === window.process) throw new s(-1, 'window.process is undefined');
      return window.process;
    },
    documentProps: function () {
      if (void 0 === window.document) throw new s(-1, 'window.document is undefined');
      return a(window.document);
    },
    windowProps: function () {
      return a(window);
    },
    osCpu: function () {
      var e = navigator.oscpu;
      if (null == e) throw new s(-1, 'navigator.oscpu is undefined');
      return e;
    },
    deviceMemory: function () {
      var e,
        n = p(((e = navigator.deviceMemory), parseFloat(e)), void 0);
      if (null == n) throw new s(-1, 'navigator.osdeviceMemorycpu is undefined');
      return n;
    },
    screenResolution: function () {
      var e = screen,
        n = function (e) {
          return p(w(e), void 0);
        },
        t = [n(e.width), n(e.height)].sort(),
        r = t[0];
      return { width: t[1], height: r };
    },
    hardwareConcurrency: function () {
      var e = p(w(navigator.hardwareConcurrency), void 0);
      if (null == e) throw new s(-1, 'navigator.hardwareConcurrency is undefined');
      return e;
    },
    platform: function () {
      var e = navigator.platform;
      if (null == e) throw new s(-1, 'navigator.platform is undefined');
      return 'MacIntel' !== e || 'webkit' !== d() || l()
        ? e
        : (function () {
            if ('iPad' === navigator.platform) return !0;
            var e = screen,
              n = e.width / e.height;
            return (
              c([
                'MediaSource' in window,
                !!Element.prototype.webkitRequestFullscreen,
                n > 0.65 && n < 1.53,
              ]) >= 2
            );
          })()
        ? 'iPad'
        : 'iPhone';
    },
    touchSupport: function () {
      var e,
        n = navigator,
        t = 0;
      void 0 !== n.maxTouchPoints
        ? (t = w(n.maxTouchPoints))
        : void 0 !== n.msMaxTouchPoints && (t = n.msMaxTouchPoints);
      try {
        document.createEvent('TouchEvent'), (e = !0);
      } catch (r) {
        e = !1;
      }
      return { maxTouchPoints: t, touchEvent: e, touchStart: 'ontouchstart' in window };
    },
    vendor: function () {
      var e = navigator.vendor;
      if (null == e) throw new s(-1, 'navigator.vendor is undefined');
      return e;
    },
  },
  m = (function () {
    function e() {
      (this.components = void 0), (this.detections = void 0);
    }
    return (
      (e.prototype.getComponents = function () {
        return this.components;
      }),
      (e.prototype.getDetections = function () {
        return this.detections;
      }),
      (e.prototype.getSources = function () {
        return h;
      }),
      (e.prototype.getDetectors = function () {
        return v;
      }),
      (e.prototype.detect = function () {
        if (void 0 === this.components)
          throw new Error("BotDetector.detect can't be called before BotDetector.collect");
        var e = this.components,
          n = this.getDetectors(),
          t = {},
          r = { bot: !1 };
        for (var o in n) {
          var i = (0, n[o])(e),
            a = { bot: !1 };
          'string' == typeof i
            ? (a = { bot: !0, botKind: i })
            : i && (a = { bot: !0, botKind: 'unknown' }),
            (t[o] = a),
            a.bot && (r = a);
        }
        return (this.detections = t), r;
      }),
      (e.prototype.collect = function () {
        return n(this, void 0, void 0, function () {
          var e,
            r,
            o,
            i = this;
          return t(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (e = this.getSources()),
                  (r = {}),
                  (o = Object.keys(e)),
                  [
                    4,
                    Promise.all(
                      o.map(function (o) {
                        return n(i, void 0, void 0, function () {
                          var n, i, a, u, c;
                          return t(this, function (t) {
                            switch (t.label) {
                              case 0:
                                (n = e[o]), (t.label = 1);
                              case 1:
                                return (
                                  t.trys.push([1, 3, , 4]), (i = r), (a = o), (c = {}), [4, n()]
                                );
                              case 2:
                                return (i[a] = ((c.value = t.sent()), (c.state = 0), c)), [3, 4];
                              case 3:
                                return (
                                  (u = t.sent()),
                                  (r[o] =
                                    u instanceof s
                                      ? {
                                          state: u.state,
                                          error: ''.concat(u.name, ': ').concat(u.message),
                                        }
                                      : {
                                          state: -3,
                                          error:
                                            u instanceof Error
                                              ? ''.concat(u.name, ': ').concat(u.message)
                                              : String(u),
                                        }),
                                  [3, 4]
                                );
                              case 4:
                                return [2];
                            }
                          });
                        });
                      })
                    ),
                  ]
                );
              case 1:
                return a.sent(), (this.components = r), [2, this.components];
            }
          });
        });
      }),
      e
    );
  })();
function g(e) {
  var r = (void 0 === e ? {} : e).monitoring,
    o = void 0 === r || r;
  return n(this, void 0, void 0, function () {
    var e;
    return t(this, function (n) {
      switch (n.label) {
        case 0:
          return (
            o &&
              (function () {
                if (!(window.__fpjs_d_m || Math.random() >= 0.001))
                  try {
                    var e = new XMLHttpRequest();
                    e.open(
                      'get',
                      'https://m1.openfpcdn.io/botd/v'.concat('1.1.0', '/npm-monitoring'),
                      !0
                    ),
                      e.send();
                  } catch (n) {
                    console.error(n);
                  }
              })(),
            [4, (e = new m()).collect()]
          );
        case 1:
          return n.sent(), [2, e];
      }
    });
  });
}
var y = { load: g };
export { s as BotdError, y as default, g as load, h as sources };
